module.exports = __webpack_public_path__ + "assets/successNote1Face-b2f965.svg";